<template>
  <div :class="_.coupon">
    <div v-if="theme.titleType !== 'none'" :class="_.hd">
      <img :src="theme.title" :class="_.title" />
    </div>
    <div :class="_.bd">
      <div :class="_.tips" v-html="theme.rule" />

      <template v-if="theme.receiveType === 'single'">
        <div :class="_.list1">
          <div
            v-for="(item, index) in curData"
            :key="item.id"
            :class="[
              _.item,
              item.resType === '103' && _.style2,
              item.extendData.status === 1 && _.ok,
              item.extendData.status === 2 && _.over,
            ]"
          >
            <div :class="_.content">
              <div :class="_.price"><span>¥</span>{{ item.amt }}</div>
            </div>
            <div :class="_.extra">
              <div :class="_.title">
                {{ item.resType === '103' ? item.title : item.subTitle }}
              </div>
              <div :class="_.expire">{{ item.subTitle }}</div>
              <div v-if="!theme.hideStockNum" :class="_.desc">
                剩{{ item.sales }}张
              </div>
            </div>
            <div
              v-track="{
                name: '领券',
                id: `${componentId}-receive`,
                resource: item,
                index: index,
              }"
              :class="_.button"
              @click="handleCouponReceiveClick(item)"
            >
              {{
                item.extendData.status === 0
                  ? '立即抢券'
                  : item.extendData.status === 1
                  ? '已领取'
                  : item.extendData.status === 2
                  ? '已领完'
                  : ''
              }}
            </div>
          </div>
        </div>
      </template>

      <template v-else>
        <div :class="_.list2">
          <div
            v-for="item in curData"
            :key="item.id"
            :class="[
              _.item,
              item.resType === '103' && _.style2,
              item.extendData.status === 1 && _.ok,
              item.extendData.status === 2 && _.over,
            ]"
          >
            <div :class="_.content">
              <div :class="_.price"><span>¥</span>{{ item.amt }}</div>
              <div :class="_.title">{{ item.title }}</div>
              <div :class="_.expire">{{ item.subTitle }}</div>
            </div>
            <div :class="_.extra">
              <div :class="_.left">{{ item.subTitle }}</div>
              <div :class="_.divider"></div>
              <div v-if="!theme.hideStockNum" :class="_.right">
                剩{{ item.sales }}张
              </div>
            </div>
            <div :class="_.badge" />
          </div>
        </div>
        <div
          v-track="{
            name: '立即领券',
            id: `${componentId}-receiveAll`,
          }"
          :class="[_.button2, _[allStatus]]"
          @click="handleCouponAllReceiveClick"
        >
          {{
            allStatus === 'available'
              ? '立即领券'
              : allStatus === 'ok'
              ? '已领取'
              : allStatus === 'over'
              ? '已领完'
              : ''
          }}
        </div>
      </template>
    </div>

    <img
      v-if="theme.hasJumpCouponButton"
      v-track="{
        name: '券包',
        id: `${componentId}-couponCenter`,
      }"
      :src="theme.jumpCouponButtonImage"
      :class="_.ft"
      @click="handleCouponCenterClick"
    />
  </div>
</template>

<script>
  import Vue from 'vue'
  import { Toast } from 'vant'
  import { wait } from 'vtils'

  export default Vue.extend({
    data() {
      return {
        curData: this.data,
      }
    },

    computed: {
      allStatus() {
        return this.curData.some(item => item.extendData.status === 0)
          ? 'available'
          : this.curData.some(item => item.extendData.status === 1)
          ? 'ok'
          : 'over'
      },
    },

    methods: {
      async refreshCouponData() {
        this.curData = (
          await this.$dmbcApi.getComponentData({
            id: this.componentId,
            pageIndex: 1,
            pageSize: 100,
            useCdn: this.pageTheme.cdn,
          })
        ).list
      },

      async handleCouponReceiveClick(coupon) {
        const loading = Toast.loading({
          message: '领取中...',
          duration: 0,
        })
        try {
          await this.$dmbcApi.receiveCoupon({
            couponActId: coupon.id,
            isStore: coupon.resType === '103',
          })
          await wait(2000)
          await this.refreshCouponData()
          loading.close()
          Toast.success('领取成功')
        } catch {
          loading.close()
        }
      },

      async handleCouponAllReceiveClick() {
        const loading = Toast.loading({
          message: '领取中...',
          duration: 0,
        })
        try {
          await Promise.all(
            this.curData
              .filter(item => item.extendData.status === 0)
              .map(coupon =>
                this.$dmbcApi.receiveCoupon({
                  couponActId: coupon.id,
                  isStore: coupon.resType === '103',
                }),
              ),
          )
          await wait(2000)
          await this.refreshCouponData()
          loading.close()
          Toast.success('领取成功')
        } catch {
          loading.close()
        }
      },

      handleCouponCenterClick() {
        window.dcb.openCouponCenter()
      },
    },
  })
</script>

<style lang="scss" module="_">
  .coupon {
    font-size: 0;
    border-radius: var(--border-radius);
  }

  .hd {
    text-align: center;

    .title {
      width: 100%;
      height: auto;
    }
  }

  .bd {
    padding: var(--padding-top) var(--padding-right) var(--padding-bottom)
      var(--padding-left);

    .tips {
      font-size: 13px;
      line-height: 18px;
      margin-bottom: 12px;
    }

    .list1 {
      .item {
        width: 100%;
        height: 82px;
        background-image: url('./images/单列优惠券_券背景.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
        display: flex;
        align-items: center;
        justify-content: center;

        .content {
          flex-shrink: 0;
          width: 98px;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;

          .price {
            font-size: 34px;
            font-weight: bold;
            color: #ff2542;
            line-height: 48px;

            span {
              font-size: 14px;
              font-weight: bold;
              color: #ff2542;
              line-height: 20px;
            }
          }
        }

        .extra {
          flex-grow: 1;
          margin-left: 15px;

          .title {
            font-size: 16px;
            font-weight: bold;
            color: #922d17;
            line-height: 22px;
            display: -webkit-box;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }

          .expire {
            display: none;
          }

          .desc {
            margin-top: 4px;
            font-size: 12px;
            color: #c38377;
            line-height: 17px;
          }
        }

        .button {
          margin-left: 4px;
          margin-right: 12px;
          flex-shrink: 0;
          width: 84px;
          height: 32px;
          background-image: url('./images/单列优惠券_按钮背景_立即抢券.png');
          background-size: 100% 100%;
          background-repeat: no-repeat;
          background-position: center;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          font-weight: bold;
          color: #ffffff;
          line-height: 20px;
          text-shadow: 0px 2px 4px rgba(242, 13, 61, 0.53);

          &:active {
            filter: contrast(0.9);
          }
        }

        &.over {
          background-image: url('./images/单列优惠券_券背景_已领完.png');

          .content {
            .price {
              color: #999999;

              span {
                color: #999999;
              }
            }
          }

          .extra {
            .title {
              color: #cbcbcb;
            }

            .desc {
              color: #cbcbcb;
            }
          }

          .button {
            background-image: url('./images/单列优惠券_按钮背景_已领完.png');
            pointer-events: none;
            text-shadow: none;
          }
        }

        &.ok {
          .button {
            background-image: url('./images/单列优惠券_按钮背景_已领取.png');
            pointer-events: none;
            text-shadow: none;
          }
        }

        + .item {
          margin-top: 12px;
        }

        &.style2 {
          background-image: url('./images/单列优惠券_券背景_门店券.png');

          .content {
            display: none;
          }

          .extra {
            margin-left: 16px;

            .title {
              display: -webkit-box;
              overflow: hidden;
              text-overflow: ellipsis;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
            }

            .expire {
              margin-top: 2px;
              font-size: 12px;
              color: #c38377;
              line-height: 17px;
              display: -webkit-box;
              overflow: hidden;
              text-overflow: ellipsis;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
            }

            .desc {
              margin-top: 8px;
              font-size: 12px;
              color: #922d17;
              line-height: 17px;
            }
          }

          .button {
            margin-left: 28px;
          }

          &.over {
            background-image: url('./images/单列优惠券_券背景_已领完_门店券.png');

            .extra {
              .title {
                color: #cbcbcb;
              }

              .expire {
                color: #cbcbcb;
              }

              .desc {
                color: #cbcbcb;
              }
            }
          }
        }
      }
    }

    .list2 {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-gap: 9px 12px;
      gap: 9px 12px;

      .item {
        position: relative;
        height: 90px;
        background-image: url('./images/两列优惠券_券背景.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;

        .content {
          width: 100%;
          height: 55px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          .price {
            font-size: 30px;
            font-weight: bold;
            color: #fe1c2e;
            line-height: 42px;

            span {
              font-size: 14px;
              font-weight: bold;
              color: #fe1c2e;
              line-height: 20px;
            }
          }

          .title {
            display: none;
          }

          .expire {
            display: none;
          }
        }

        .extra {
          margin-top: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 11px;
          color: #922d17;

          .divider {
            margin: 0 6px;
            width: 1px;
            height: 10px;
            background: #f5c5b3;
            border-radius: 1px;
          }
        }

        .badge {
          position: absolute;
          top: 0;
          right: 0;
          width: 48px;
          height: 40px;
          background-size: 100% 100%;
          background-repeat: no-repeat;
          background-position: center;
          display: none;
        }

        &.over {
          background-image: url('./images/两列优惠券_券背景_已领完.png');

          .content {
            .price {
              color: #999999;

              span {
                color: #999999;
              }
            }
          }

          .extra {
            color: #999999;

            .divider {
              background: #cbcbcb;
            }
          }

          .badge {
            display: initial;
            background-image: url('./images/两列优惠券_角标_已领完.png');
          }
        }

        &.ok {
          .badge {
            display: initial;
            background-image: url('./images/两列优惠券_角标_已领取.png');
          }
        }

        &.style2 {
          .content {
            .price {
              display: none;
            }

            .title {
              padding: 0 4px;
              font-size: 14px;
              font-weight: bold;
              color: #922d17;
              line-height: 20px;
              display: -webkit-box;
              overflow: hidden;
              text-overflow: ellipsis;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
            }

            .expire {
              padding: 0 4px;
              margin-top: 2px;
              font-size: 12px;
              color: #c38377;
              line-height: 17px;
              display: -webkit-box;
              overflow: hidden;
              text-overflow: ellipsis;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
            }
          }

          .extra {
            .left,
            .divider {
              display: none;
            }
          }

          &.ok,
          &.over {
            .badge {
              top: initial;
              bottom: 0;
            }
          }

          &.over {
            background-image: url('./images/两列优惠券_券背景_已领完.png');

            .content {
              .title,
              .expire {
                color: #999999;
              }
            }
          }
        }
      }
    }

    .button2 {
      margin-top: 12px;
      height: 50px;
      background: linear-gradient(180deg, #ff5b80 0%, #f20d1b 100%);
      border-radius: 25px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      font-weight: bold;
      color: #ffffff;

      &:active {
        filter: contrast(0.9);
      }

      &.ok {
        background: linear-gradient(180deg, #ff5b80 0%, #f20d1b 100%);
        opacity: 0.3;
        pointer-events: none;
      }

      &.over {
        background: #d4d4d4;
        pointer-events: none;
      }
    }
  }

  .ft {
    width: 100%;
    height: auto;
  }
</style>
